<!-- NGX Bootstrap Modal -->
<div class="modal-content init-modal">
  <button
    type="button"
    class="btn-close init-modal__close"
    (click)="closeModal()"
    aria-label="Close"
  ></button>

  <div class="init-modal__body">
    <!-- Header with gradient -->
    <div class="init-modal__headline">
      <h2 class="init-modal__title">
        Introducing
        <img
          src="../../../assets/nice-labs-logo.svg"
          alt="NiceLabs Logo"
          class="init-modal__logo"
        />
      </h2>
    </div>

    <!-- Body Copy -->
    <div class="init-modal__text">
      <p class="init-modal__intro">
        From the team behind NiceProject comes a new platform where IT
        practitioners teach practitioners.
      </p>
      <ul>
        <li>Certified skills to boost your career</li>
        <li>Accelerated learning paths for IT professionals</li>
        <li>Networking opportunities with industry experts</li>
      </ul>

      <p class="init-modal__summary">
        Grow in a <em class="init-modal__highlight">nice</em> atmosphere!
      </p>
    </div>

    <!-- CTA Buttons -->
    <div class="init-modal__actions">
      <a
        href="https://nicelabs.eu/"
        target="_blank"
        class="btn btn-primary init-modal__button init-modal__button--primary"
      >
        Discover NiceLabs.eu
        <i class="ri-arrow-right-line"></i>
      </a>
    </div>
  </div>
</div>
